import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8ddc8762&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=8ddc8762&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ddc8762",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ddc8762')) {
      api.createRecord('8ddc8762', component.options)
    } else {
      api.reload('8ddc8762', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8ddc8762&scoped=true", function () {
      api.rerender('8ddc8762', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/generalTableColumn/index.vue"
export default component.exports